define(function(require) {
	// general
	const ViewManager = require('civicsUtils/view_manager');
	const MimeUtil = require('civicsUtils/mimetype_utilities');
	const Utils = require('civicsUtils/general_utilities');
	// models
	const AttachmentModel = require('civicsModels/attachment_model');
  const DocumentTypeCollection = require('civicsCollections/document_type_collection');
	const IpsModel = require('civicsBase/ipsModel');


	// templates
	const tpl = require('civicsViews/new_attachments/upload_modal/templates/t_itv_add_attachment.hbs');
	const AttributesTable = require('civicsViews/attachments/v_cpv_attributes');
	const constants = require('civicsUtils/constants');

	return Marionette.LayoutView.extend({
		initialize: function(options) {
			this.config = options.config || {};
			this.config.globalConfig = ViewManager.globalConfig();
			this.productFamily = options.productFamily;
			this.catalog = options.catalog;
			this.parentMoniker = options.parentMoniker;
			this.parentPrimaryKey = options.parentPrimaryKey;
			this.isAddProcess = options.isAddProcess;
			this.hasValidAttachment = true;
			this.documentTypeCollection = options.documentTypeCollection;
			this.isCustomer = options.isCustomer;
			this.isProvider = options.isProvider;
			this.validDocumentTypes = this.loadDocumentTypes();
			this.attachment_index = options.attachment_index;


		},
		template: tpl,
		tagName: 'li',
		className: 'attachment-upload',
		modelEvents: {
			change: 'render',
		},
		events: {
			'click .delete-button': 'deleteAttachment',
			'droppyChange @ui.documentType': 'onDocumentTypeChanged',
		},
		ui: {
			deleteBtn: '.delete-button',
			failed: '.rule-failed',
			passed: '.rule-passed',
			comments: '.field-description .input-textarea',
			attachmentComments: '.description',
			imagePreview: '.image-thumbnail',
			nonImagePreview: '.non-image-thumbnail',
			preview: '.preview',
			documentType: '.document-type',
			$attributeTable: '.table-container',
		},
		regions: {
			attributeRegion: '@ui.$attributeTable'
		},
		templateHelpers: function() {
			var self = this;
			var documentTypesSorted = _.sortBy(self.validDocumentTypes.toJSON(), function(o) {
				return o.name;
			});
			return {
				singleDocumentType: (typeof self.validDocumentTypes !== 'undefined' && self.validDocumentTypes.length == 1),
				documentTypes: documentTypesSorted,
				fileType: self.model.get('fileName').substring(self.model.get('fileName').lastIndexOf('.')),
				deleteLabel: i18n.t('CIVICS.COMMON.DELETE_THIS', { type: i18n.t('CIVICS.ATTACHMENTS.ATTACHMENT'), id: self.model.get('fileName') }),
				attachment_index : this.attachment_index ? this.attachment_index : 0
			};
		},
		onShow: function() {
			var self = this;
			this.ui.$attributeTable.hide();
			this.ui.imagePreview.hide();
			this.ui.nonImagePreview.hide();

			if (self.model.get('File')) {

				var mimeType = self.model.get('File').type;

				if (typeof self.ui.imagePreview === 'object' || typeof self.ui.nonImagePreview === 'object') {
					if (mimeType != null && mimeType.split('/')[0] === 'image') {

						var attachmentReader = new FileReader();
						attachmentReader.onload = function(e) {
							if (typeof self.ui.imagePreview === 'object') {
								self.ui.imagePreview.attr('src', e.target.result);
								if(window.matchMedia("(max-width: 767px)").matches) {
									self.ui.imagePreview.parent().css({'max-width':'150px', 'margin-bottom':'30px'});
								} else {
									self.ui.imagePreview.parent().css('max-width', '200px');
								}
								self.ui.imagePreview.parent().css('max-height', '200px');
								self.ui.imagePreview.css('width', '100%');
								self.ui.imagePreview.css('height', '100%');
							}

						}
						attachmentReader.readAsDataURL(self.model.get('File'));
						self.ui.imagePreview.show();
					} else {
						self.ui.nonImagePreview.show();
					}
				}


				if (self.validDocumentTypes.length == 1 || (typeof self.model.get('documentType') !== 'undefined' && typeof self.ui.documentType === 'object')) {
					self.onDocumentTypeChanged();
				}
			}

		},
		onRender: function() {
			this.$el.rhythmCivicsTooltipInit();
			this.$el.rhythmThemeInit();
			this.$el.find('textarea:not([aria-labelledby|="character-count-label"])').each(function(index, ta) {
				$(ta).maxlength();
			});
		},
		validateChildViewAttachment: function(view) {
			var self = this;
			self.clearErrorMessage();
			self.triggerMethod('attachment:before:save', view);
		},
		validateChildViewAttachment2: function() {
			var self = this;
			var data = Backbone.Syphon.serialize(self);
			self.hasValidAttachment = true;
			var validationError = {};
			var hasError = false;

			self.clearErrorMessage();
			
			//Get config values
			var maxSize = self.config.globalConfig.get("attachments").get("maxFileSize") * 1048576;
			var mimeTypes = self.config.globalConfig.get("attachments").get("mimeTypes");
			var allowedExts = self.config.globalConfig.get("attachments").get("allowedExtensions");
			if( allowedExts == undefined ) allowedExts = "";

			/*Validation for the file size*/
			var tempFile = self.model.get('file');
			if (tempFile.size > maxSize || tempFile.size > 252144000 ) {		//250MB max allowed regardless of config
				self.showError(i18n.t('CIVICS.ATTACHMENTS.UPLOAD_SIZE_ERROR'));
				self.hasValidAttachment = false;
			}

			/*Check for the mime type and/or extension type*/
			var mimeType = tempFile.type;
			var ext = tempFile.name.substring(tempFile.name.lastIndexOf('.'));
			if (tempFile.type.length == 0 && tempFile.name.length > 0 && tempFile.name.lastIndexOf('.') > 0) {
				mimeType = MimeUtil.getMimeType(ext);
			}
			if (typeof mimeType === 'undefined' || mimeType.length == 0 || mimeTypes.indexOf(mimeType) < 0) {
				//mime type is invalid.  Check the extension
				if( allowedExts.toLowerCase().indexOf(ext.toLowerCase()) < 0 ) {
					self.showError(i18n.t('CIVICS.ATTACHMENTS.UPLOAD_TYPE_ERROR'));
					self.hasValidAttachment = false;
				}
			}

				var error = {};
				if (typeof data.documentType === 'undefined' || data.documentType.length == 0) {
					//show error message that documenttype is required.
					error.validationError = {};
					error.validationError.documentType = i18n.t('CIVICS.ATTACHMENTS.DOCUMENT_TYPE_REQUIRED');
					hasError = true;
				} else {
					var attributes = [];
					if (typeof self.attributesTableView !== 'undefined' && self.attributesTableView.numDisplayedAttributes > 0) {
						var attributeData = ViewManager.fromWindow(self);
						var requiredAttributes = {};
						var requiredDocTypes = {};
						var numbers = ["integer", "short", "long", "float8", "currency", "decimal"];

						var docType = this.validDocumentTypes.find(function(type) {
							return self.selectedDocumentType.get('name') === type.get('name');
						});

						docType.get('attributes').each(function(a) {
							requiredAttributes[a.get('name')] = a.get('isRequired');
							requiredDocTypes[a.get('name')] = a.get('type');
						});

						for (attribute in attributeData) {
							if (requiredAttributes[attribute] == true && (_.isEmpty(attributeData[attribute]) || attributeData[attribute] == constants.DATE_TIME_MIN_VAL
							|| (numbers.indexOf(requiredDocTypes[attribute].toLowerCase()) != -1 && attributeData[attribute].toString() == '0' ))) {
								if (!this.isAddProcess) {
									hasError = true;
									validationError[attribute] = i18n.t('CIVICS.ATTACHMENTS.ATTRIBUTE_REQUIRED');
								}
							}
						}
					}
				}

				if (hasError) {
					self.hasValidAttachment = false;
					if (error)
						ViewManager.errorToWindow(error, this);

					if (!_.isEmpty(validationError) && !self.isAddProcess)
						this.displayAttributeErrors(validationError);
				}

		},
		createNewAttachmentModel: function(catalog){
			var self = this;
			var data = Backbone.Syphon.serialize(self);
			ViewManager.resetErrorMessages(self);

			var tempFile = this.model.get('file');

			var myModel = new AttachmentModel();


			myModel.set('file', tempFile);
			myModel.set('description', data.description);
			myModel.set('fileName',this.model.get('fileName'));

			myModel.set('parentMoniker', self.parentMoniker);
			myModel.set('parentPrimaryKey', self.parentPrimaryKey);
			myModel.set('title', data.title);
			myModel.set('provider',catalog);

			var actualDocType = self.documentTypeCollection.find(function(doctype) {
				return doctype.get('name') == data.documentType;
			});

			var doctypeJSON = actualDocType.toJSON();

			myModel.set('documentType', new IpsModel({
				'name': doctypeJSON.name,
				'attributes': doctypeJSON.attributes
			}));

			this.addAttributesToModel(myModel);

			return myModel;
		},

		addAttributesToModel: function(myModel) {
			var self = this;
			var missingRequirements = [];
			var attributes = [];

			if (typeof self.attributesTableView !== 'undefined' && self.attributesTableView.numDisplayedAttributes > 0) {
				var attributeData = ViewManager.fromWindow(self.ui.$attributeTable);

				var attr = Backbone.Syphon.serialize(self.ui.$attributeTable);
				var requiredAttributes = {};

				self.selectedDocumentType.get('attributes').each(function(a) {
					requiredAttributes[a.get('name')] = a.get('isRequired');
				});

				for (attribute in attributeData) {
					if (self.isAddProcess) {
						if (requiredAttributes[attribute] == true && (_.isEmpty(attributeData[attribute]) || attributeData[attribute] == constants.DATE_TIME_MIN_VAL))
							missingRequirements.push(attribute);
					}

					if ((typeof attributeData[attribute] != 'undefined' && !_.isEmpty(attributeData[attribute])) || typeof attributeData[attribute] == 'boolean' ) {
						attributes.push({
							"name": attribute,
							"value": attributeData[attribute]
						});
					}
				}
			}

			var docType = myModel.get('documentType');
			docType.set('attributes', attributes);

			//myModel.set('documentType',new IpsModel(docType));
			myModel.set('missingRequirements',missingRequirements);

		},
		onUploadSave: function(catalog) {
			var self = this;
			var def = new $.Deferred();

			var myModel = this.createNewAttachmentModel(catalog);

			var shouldWeSave = !this.isAddProcess;

			if (shouldWeSave) {
				myModel.isSave = true;
				myModel.save(null, {
					success: function(model, response, options) {
						self.ui.deleteBtn.hide();
						self.ui.comments.attr('disabled', true);
						var responseData = response.data[0];
						myModel.set('filename',responseData.filename);
						myModel.set('documentUri', responseData.documentUri);
						myModel.set('id',responseData.id);
						myModel.set('mimeType',responseData.mimeType);
						myModel.set('provider',responseData.provider);
						myModel.set('supportedOptions',responseData.supportedOptions);
						myModel.set('thumbnailMimeType',responseData.thumbnailMimeType);
						myModel.set('thumbnailUri',responseData.thumbnailUri);
						myModel.set('title',responseData.title);
						myModel.set('addedDateTime',responseData.addedDateTime);

						self.showSuccess(i18n.t('CIVICS.ATTACHMENTS.UPLOADED_AND_SAVED'));

						self.triggerMethod('attachment:post:save', myModel);
						def.resolve(myModel);
					},
					error: function(model, response, options) {
						self.ui.deleteBtn.show();
						self.showError(i18n.t('CIVICS.ATTACHMENTS.ERROR_UPLOADING_FILE'));
						def.reject();
					},
				});
			} else {
				self.ui.comments.attr('disabled', true);
				self.showSuccess(i18n.t('CIVICS.ATTACHMENTS.UPLOADED_AND_SAVED'));
				self.triggerMethod('attachment:post:save', myModel);
				def.resolve(myModel);
			}

			return def.promise();
		},
		onSaveDescription: function() {
			var self = this;
			var data = Backbone.Syphon.serialize(this);


			var attributes = [];
			var documentType = {};
			var droppyValue = data.documentType;

			if (typeof droppyValue !== 'undefined' && droppyValue.length > 0) {

				if (typeof self.attributesTableView !== 'undefined' && self.attributesTableView.numDisplayedAttributes > 0) {
					var attributeData = ViewManager.fromWindow(self.ui.$attributeTable);
					for (attribute in attributeData) {
						attributes.push({
							"name": attribute,
							"value": attributeData[attribute]
						});
					}
				}

				documentType = {
					"name": data.documentType,
					"attributes": attributes
				};

				self.model.set("documentType", documentType);
				self.model.set('title', data.title);
			}

			this.model.set('description', data.description);
		},
		deleteAttachment: function() {
			this.triggerMethod('attachment:remove');
		},
		clearErrorMessage: function() {
			this.ui.failed.find('.error-message').remove();
			ViewManager.resetErrorMessages(this);
		},
		showError: function(message) {
			if (this.ui.failed.text().indexOf(message) < 0) {
				var newError = $('<div class="error-message"></div>');
				newError.append(Utils.outputErrorMessage(message));
				this.ui.failed.append(newError);
			}
			this.ui.failed.show().parent().get(0).focus();
		},
		showSuccess: function(message) {
			this.ui.passed.append(message);
			this.ui.passed.show();
		},
		loadDocumentTypes: function() {
			var self = this;
			var filteredTypeCollection = new DocumentTypeCollection();
			this.documentTypeCollection.each(function(type) {
				var description = type.get('description') != null ? type.get('description') : type.get('name');
				type.set('description', description);
				var p = type.get('permissions');

				if(p.get('add')) {
					filteredTypeCollection.add(type);
				}
			});

			return filteredTypeCollection;
		},
		onDocumentTypeChanged: function() {
			this.selectedDocumentType = null;
			var self = this;
			var droppyValue = Utils.civicsDropdownValue(this.ui.documentType);

			this.selectedDocumentType = this.validDocumentTypes.find(function(type) {
				return type.get('name') === droppyValue;
			});

			if (droppyValue.length > 0 || self.validDocumentTypes.length == 1) {

				var attributesCollection = new Backbone.Collection(self.selectedDocumentType.get('attributes').toJSON());

				this.buildAttributeTable(attributesCollection);
			} else {
				self.ui.$attributeTable.hide();
			}

		},
		buildAttributeTable: function(attributesCollection) {
			var self = this;
			var today = new Date();

			var filteredAttributes = new Backbone.Collection(attributesCollection.toJSON());

			if (filteredAttributes.length > 0) {

				filteredAttributes.comparator = function(model) {
					return model.get('displayOrder');
				};
				filteredAttributes.sort();

				if (typeof self.model.get('documentType') !== 'undefined') {
					var attributesFromModel = (typeof self.model.get('documentType').attributes !== 'undefined') ? self.model.get('documentType').attributes : "";

					if (attributesFromModel.length > 0) {
						filteredAttributes.each(function(item) {
							item.set('attributeValue', null);

							var attrib = attributesFromModel.find(function(attr) {
								return attr.name == item.get('name');
							});
							if (attrib != null) {
								item.set('attributeValue', attrib.value);
							}
						});
					}
				} else {
					//reset attributeValue.
					filteredAttributes.each(function(item) {
						item.set('attributeValue', null);
					});
				}

				this.attributesTableView = new AttributesTable({
					config: self.config,
					collection: filteredAttributes,
					numDisplayedAttributes: filteredAttributes.length,
					canUpdate: true,
					attachment_index:this.attachment_index
				});

				self.attributeRegion.show(this.attributesTableView);
				self.ui.$attributeTable.show();
			} else {
				self.ui.$attributeTable.hide();
			}
		},
		displayAttributeErrors: function(validationError) {
			// ViewManager.errorToWindow doesn't work here
			// because the fields are formatted differently
			for (error in validationError) {
				var selector = "[name='{0}']".format(error);
				var formElement = this.ui.$attributeTable.find(selector);

				var newError = $('<div class="helper-msg-container"><div class="error-message"></div></div>');
				newError.find(".error-message").append(Utils.outputErrorMessage(ViewManager.htmlSafeString(validationError[error])));

				formElement.closest('div.field').append(newError);
				formElement.parents('.field').addClass('error');
			}
			this.showError(i18n.t('CIVICS.ATTACHMENTS.MISSING_REQUIRED_INFO'));
		},
	});
});
